var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    ("cv-breadcrumb-item " + _vm.carbonPrefix + "--breadcrumb-item"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--breadcrumb-item--current")] = _vm.activePage, _obj ) ],attrs:{"aria-current":_vm.ariaCurrent}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }